'use client';

import SuperTokensReact from 'supertokens-auth-react';
import EmailPasswordReact from 'supertokens-auth-react/recipe/emailpassword';
import SessionReact from 'supertokens-auth-react/recipe/session';

/**
 * 내부(IP/localhost HTTP) 접속 여부 판별
 * 내부 접속 시 header 모드로 토큰 전송 (Secure 쿠키 제약 우회)
 */
function isInternalAccess(): boolean {
  if (typeof window === 'undefined') return false;
  const { protocol, hostname } = window.location;
  return protocol === 'http:' && (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)
  );
}

export function getSupertokensClientConfig() {
  // 브라우저 접속 URL을 동적으로 사용 (내부/외부 동시 접속 지원)
  const origin = typeof window !== 'undefined' ? window.location.origin : 'https://erp.deeppos.io';
  const useHeaderAuth = isInternalAccess();

  return {
    appInfo: {
      appName: '비서단 ERP',
      apiDomain: origin,
      websiteDomain: origin,
      apiBasePath: '/api/auth',
      websiteBasePath: '/login',
    },
    recipeList: [
      EmailPasswordReact.init(),
      SessionReact.init({
        // 내부 HTTP 접속: header 모드 (Authorization 헤더로 토큰 전송)
        // 외부 HTTPS 접속: cookie 모드 (기본값, 가장 안전)
        ...(useHeaderAuth ? { tokenTransferMethod: 'header' as const } : {}),
      }),
    ],
  };
}

let initialized = false;

export function ensureSuperTokensFrontendInit() {
  if (typeof window !== 'undefined' && !initialized) {
    SuperTokensReact.init(getSupertokensClientConfig());
    initialized = true;
  }
}
